
import React, { useState } from 'react';
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useToast } from "@/components/ui/use-toast";

export default function PreferencesTab() {
  const { toast } = useToast();
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [isCompactView, setIsCompactView] = useState(false);
  const [chartType, setChartType] = useState("candle");
  const [timeZone, setTimeZone] = useState("America/New_York");

  const handleSave = () => {
    toast({
      title: "Preferences Saved",
      description: "Your preferences have been updated successfully.",
    });
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h2 className="text-2xl font-semibold text-white mb-2">Display Preferences</h2>
        <p className="text-stewie-gray">
          Customize how Stewie Trader appears and works for you.
        </p>
      </div>

      <div className="settings-card">
        <h3 className="settings-header">Appearance</h3>
        
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label className="text-white cursor-pointer">Dark Mode</Label>
              <p className="text-xs text-stewie-gray">Use dark color scheme for the application</p>
            </div>
            <Switch
              checked={isDarkMode}
              onCheckedChange={setIsDarkMode}
              className="data-[state=checked]:bg-stewie-blue"
            />
          </div>
          
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label className="text-white cursor-pointer">Compact View</Label>
              <p className="text-xs text-stewie-gray">Display more content with reduced spacing</p>
            </div>
            <Switch
              checked={isCompactView}
              onCheckedChange={setIsCompactView}
              className="data-[state=checked]:bg-stewie-blue"
            />
          </div>
          
          <div className="space-y-2 pt-2">
            <Label htmlFor="chart-type" className="text-white">Default Chart Type</Label>
            <Select value={chartType} onValueChange={setChartType}>
              <SelectTrigger className="w-full bg-stewie-dark border-stewie-gray/30 text-white">
                <SelectValue placeholder="Select chart type" />
              </SelectTrigger>
              <SelectContent className="bg-stewie-charcoal border-stewie-gray/30 text-white">
                <SelectItem value="candle" className="hover:bg-stewie-blue/20">Candlestick</SelectItem>
                <SelectItem value="line" className="hover:bg-stewie-blue/20">Line Chart</SelectItem>
                <SelectItem value="area" className="hover:bg-stewie-blue/20">Area Chart</SelectItem>
                <SelectItem value="bar" className="hover:bg-stewie-blue/20">Bar Chart</SelectItem>
              </SelectContent>
            </Select>
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="time-zone" className="text-white">Time Zone</Label>
            <Select value={timeZone} onValueChange={setTimeZone}>
              <SelectTrigger className="w-full bg-stewie-dark border-stewie-gray/30 text-white">
                <SelectValue placeholder="Select time zone" />
              </SelectTrigger>
              <SelectContent className="bg-stewie-charcoal border-stewie-gray/30 text-white max-h-80">
                <SelectItem value="America/New_York" className="hover:bg-stewie-blue/20">Eastern Time (US & Canada)</SelectItem>
                <SelectItem value="America/Chicago" className="hover:bg-stewie-blue/20">Central Time (US & Canada)</SelectItem>
                <SelectItem value="America/Denver" className="hover:bg-stewie-blue/20">Mountain Time (US & Canada)</SelectItem>
                <SelectItem value="America/Los_Angeles" className="hover:bg-stewie-blue/20">Pacific Time (US & Canada)</SelectItem>
                <SelectItem value="Europe/London" className="hover:bg-stewie-blue/20">London</SelectItem>
                <SelectItem value="Europe/Paris" className="hover:bg-stewie-blue/20">Paris</SelectItem>
                <SelectItem value="Asia/Tokyo" className="hover:bg-stewie-blue/20">Tokyo</SelectItem>
                <SelectItem value="Asia/Hong_Kong" className="hover:bg-stewie-blue/20">Hong Kong</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>

      <div className="settings-card">
        <h3 className="settings-header">Trading Preferences</h3>
        
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label className="text-white cursor-pointer">Trade Confirmations</Label>
              <p className="text-xs text-stewie-gray">Show confirmation dialog before executing trades</p>
            </div>
            <Switch defaultChecked className="data-[state=checked]:bg-stewie-blue" />
          </div>
          
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label className="text-white cursor-pointer">Real-time Price Updates</Label>
              <p className="text-xs text-stewie-gray">Continuously update prices in real-time</p>
            </div>
            <Switch defaultChecked className="data-[state=checked]:bg-stewie-blue" />
          </div>
          
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label className="text-white cursor-pointer">Sound Alerts</Label>
              <p className="text-xs text-stewie-gray">Play sound when trades execute or alerts trigger</p>
            </div>
            <Switch defaultChecked={false} className="data-[state=checked]:bg-stewie-blue" />
          </div>
        </div>
      </div>

      <div className="flex justify-end pt-4">
        <Button onClick={handleSave} className="bg-stewie-blue hover:bg-stewie-blue/80">
          Save Preferences
        </Button>
      </div>
    </div>
  );
}
